export default "__VITE_ASSET__8d685217__"